import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { consumeSearchFlowNavigation } from "../../../Lib/Utils/searchFlowNavigation";
import { MainBookingContext } from "../Context/MainBookingContext";

class MainBookingInit extends StepFlow {
    get stepName() { return "MainBookingInit_Step"; }

    async onEventSetup(): Promise<void> {
    }

    async onExecute(): Promise<void> {
        console.log("Main Booking Init Step Executed.....");

        //This will start search flow from Main Booking Flow
        let context = this.getCtx<MainBookingContext>("MainBookingContext")!

        if (!context) {
            const mainBookingContext = new MainBookingContext()

            // This code is to skip search flow and execute select offer flow for destination detail page
            const isFromDestinationDetail = sessionStorage.getItem('isFromDestinationDetail') === "true";
            sessionStorage.removeItem('isFromDestinationDetail')
            mainBookingContext.isFromDestinationDetail = isFromDestinationDetail;

            this.setCtx<MainBookingContext>("MainBookingContext", mainBookingContext)
            context = this.getCtx<MainBookingContext>("MainBookingContext")!
        }
        const pathname = typeof window !== "undefined" ? window.location.pathname : "";

        // When the user navigates back to the home/search page (top-bar logo or
        // bottom-nav "Search"), the flow is restarted via FLOW_CHANGE *before* the
        // route change to "/search" finishes, so window.location.pathname can still
        // read "/train-offer". Without this guard the init step would take the
        // hard-refresh branch below and mount the offer flows instead of SearchFlow,
        // leaving the search bar's Search button with no event subscriber.
        const isNavigatingToSearch = consumeSearchFlowNavigation();

        if (!isNavigatingToSearch && pathname === "/train-offer") {
            // On hard refresh at train-offer page, mount offer/ticket flows directly
            // so event subscriptions are active before user interactions.
            context.routeTo = ["SelectOfferFlow", "TicketOptionFlow"];
            this.next();
            return;
        }

        context.routeTo = ["SearchFlow"]
        this.next();

    }
}

export const mainBookingInitStepDeclaration = new StepDefinition({
    stepName: "MainBookingInit_Step",
    stepClass: MainBookingInit
});
